import React, { useContext, useState } from "react";
import "firebase/auth";
import "../../App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import { UserContext } from "../../App";
import { verifyTotp } from "../../utils/account";
import { useHistory } from "react-router-dom";
import { auth } from "../../index";

export default function Totp(props) {
  const { userInfos } = useContext(UserContext);

  const [error, setError] = useState(null);
  const [totpCode, setTotpCode] = useState("");
  const [isFetching, setIsFetching] = useState(false);
  const history = useHistory();

  async function submitTotpCode(e) {
    e.preventDefault();

    setIsFetching(true);

    try {
      const result = await verifyTotp(userInfos.jwt, totpCode);
      if (result) history.push("/");
      else setError("Code de double authentification incorrect");
    } catch (error) {
      console.error(error.code);
    }

    setIsFetching(false);
  }

  async function onClickLogout(e) {
    e.preventDefault();

    localStorage.removeItem("totpJwt");
    await auth.signOut();
  }

  return (
    <div className="position-relative overflow-hidden auth-bg min-vh-100 w-100 d-flex align-items-center justify-content-center">
      <div className="d-flex align-items-center justify-content-center w-100">
        <div className="row justify-content-center w-100 my-5 my-xl-0">
          <div className="col-md-9 d-flex flex-column justify-content-center">
            <div className="card mb-0 bg-body auth-login m-auto w-100">
              <div className="row gx-0">
                <div className="col-xl-6 border-end">
                  <div className="row justify-content-center py-4">
                    <div className="col-lg-11">
                      <div className="card-body">
                        <a
                          href="https://zeplan.ai/totp"
                          className="text-nowrap logo-img d-block mb-4 w-100"
                        >
                          <img
                            src="https://zeplan.ai/wp-content/uploads/2024/04/Document-size-Black.png"
                            className="dark-logo"
                            alt="Logo-Dark"
                            style={{ width: "150px" }}
                          />
                        </a>
                        <h2 className="lh-base mb-4">
                          Connectez vous à ZEPLAN
                        </h2>
                        <form onSubmit={submitTotpCode}>
                          {error ? (
                            <div
                              className="alert alert-danger alert-dismissible"
                              role="alert"
                            >
                              <div className="alert-text">{error}</div>
                              <div className="alert-close">
                                <i
                                  className="flaticon2-cross kt-icon-sm"
                                  data-dismiss="alert"
                                ></i>
                              </div>
                            </div>
                          ) : null}

                          <div className="mb-3">
                            <label htmlFor="email" className="form-label">
                              Code de double authentification
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="XXXXXX"
                              name="totp"
                              autoComplete="off"
                              onChange={(e) => setTotpCode(e.target.value)}
                              value={totpCode}
                              style={{ background: "rgb(109, 98, 141, 12%)" }}
                            />
                          </div>

                          <button
                            type="submit"
                            className="btn btn-dark w-100 py-8 mb-4 rounded-1"
                            disabled={isFetching}
                          >
                            Valider
                          </button>
                          <div className="d-flex align-items-center">
                            <p className="fs-12 mb-0 fw-medium">Ou </p>
                            <button
                              className="text-primary fw-semibold ms-2"
                              style={{
                                backgroundColor: "transparent",
                                border: "none",
                                cursor: "pointer",
                                padding: "0",
                                margin: "0",
                              }}
                              onClick={onClickLogout}
                            >
                              se déconnecter
                            </button>
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-xl-6 d-none d-xl-block">
                  <div className="row justify-content-center align-items-start h-100">
                    <div className="col-lg-9">
                      <div
                        id="auth-login"
                        className="carousel slide auth-carousel mt-5 pt-4"
                        data-bs-ride="carousel"
                        data-bs-interval="5000"
                      >
                        <div className="carousel-indicators">
                          <button
                            type="button"
                            data-bs-target="#auth-login"
                            data-bs-slide-to="0"
                            className="active"
                            aria-current="true"
                            aria-label="Slide 1"
                          ></button>
                          <button
                            type="button"
                            data-bs-target="#auth-login"
                            data-bs-slide-to="1"
                            aria-label="Slide 2"
                          ></button>
                          <button
                            type="button"
                            data-bs-target="#auth-login"
                            data-bs-slide-to="2"
                            aria-label="Slide 3"
                          ></button>
                        </div>
                        <div className="carousel-inner">
                          <div className="carousel-item active">
                            <div className="d-flex align-items-center justify-content-center w-100 h-100 flex-column gap-9 text-center">
                              <img
                                src="https://zeplan.ai/wp-content/uploads/2024/04/Document-size-Black.png"
                                alt="login-side-img"
                                width="300"
                                className="img-fluid"
                              />
                              <h4 className="mb-0">Optimisez votre temps</h4>
                              <p className="fs-12 mb-0">
                                Zeplan est votre outil ultime pour optimiser la
                                gestion des courses VTC. Gagnez en efficacité
                                grâce à nos graphiques avancés et à notre
                                interface intuitive.
                              </p>
                              <a
                                href="javascript:void(0)"
                                className="btn btn-primary rounded-1"
                              >
                                En savoir plus
                              </a>
                            </div>
                          </div>
                          <div className="carousel-item">
                            <div className="d-flex align-items-center justify-content-center w-100 h-100 flex-column gap-9 text-center">
                              <img
                                src="https://zeplan.ai/wp-content/uploads/2024/04/Document-size-Black.png"
                                alt="login-side-img"
                                width="300"
                                className="img-fluid"
                              />
                              <h4 className="mb-0">
                                Gestion de nombreuses données
                              </h4>
                              <p className="fs-12 mb-0">
                                Optimisez votre flotte de VTC avec Zeplan.
                                Visualisez les données critiques et prenez des
                                décisions éclairées pour maximiser la
                                satisfaction des clients.
                              </p>
                              <a
                                href="javascript:void(0)"
                                className="btn btn-primary rounded-1"
                              >
                                En savoir plus
                              </a>
                            </div>
                          </div>
                          <div className="carousel-item">
                            <div className="d-flex align-items-center justify-content-center w-100 h-100 flex-column gap-9 text-center">
                              <img
                                src="https://zeplan.ai/wp-content/uploads/2024/04/Document-size-Black.png"
                                alt="login-side-img"
                                width="300"
                                className="img-fluid"
                              />
                              <h4 className="mb-0">Un outil connecté</h4>
                              <p className="fs-12 mb-0">
                                Zeplan simplifie la gestion de votre service de
                                VTC. Suivez les performances en temps réel et
                                optimisez vos ressources pour une rentabilité
                                accrue.
                              </p>
                              <a
                                href="javascript:void(0)"
                                className="btn btn-primary rounded-1"
                              >
                                En savoir plus
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
